import { apiCall} from "../../../utils/api.utils";
import { API_URLS } from "../../../constants/apiUrls";

export const cardStatementService = {
    getCardStatement,
    getNewCardStatement,
    getNewCardStatementAdmin,
};

function getCardStatement(cardPan, data) {
    return apiCall("POST", `${API_URLS.CARD_MANAGEMENT.GET_CARD_STATEMENT}/${cardPan}`, null, data);
}

function getNewCardStatement(params, data,customHeader) {
    
        if (params && params.fileType) {
       
        if(params.fileType==='PDF'){
            
            params['encode']=true;
            return apiCall("POST", `${API_URLS.CARD_MANAGEMENT.GET_CARD_STATEMENT_RECORD}/download`, null, data, params);  
        }else{
            
            return apiCall("POST", `${API_URLS.CARD_MANAGEMENT.GET_CARD_STATEMENT_RECORD}/download`, null, data, params);     
        }
        
    } else {
        
        return apiCall("POST", `${API_URLS.CARD_MANAGEMENT.GET_CARD_STATEMENT_RECORD}`,null, data, params);
    }
}

function getNewCardStatementAdmin(params, data,customHeader) {
 
        if (params && params.fileType) {
       
        if(params.fileType==='PDF'){
            
            params['encode']=true;
            return apiCall("POST", `${API_URLS.CARD_MANAGEMENT.GET_CARD_STATEMENT_RECORD_ADMIN}/download`, null, data, params);  
        }else{
            
            return apiCall("POST", `${API_URLS.CARD_MANAGEMENT.GET_CARD_STATEMENT_RECORD_ADMIN}/download`,null, data, params);     
        }
        
    } else {
        
        return apiCall("POST", `${API_URLS.CARD_MANAGEMENT.GET_CARD_STATEMENT_RECORD_ADMIN}`,null, data, params);
    }
}
